export const ASSET_IMAGES = process.env.REACT_APP_IMAGES_PATH;
export const ASSET_AVATARS = ASSET_IMAGES + '/avatar';
export const ASSET_LOGOS = ASSET_IMAGES + '/logos';
export const USE_IMAGE_PLACEHOLDERS = false;
